export default "__VITE_ASSET__BhqrMTsk__"